module.exports = __webpack_public_path__ + "static/blockfundation-1c53a2e57356920adafb910e4754f717.jpg";